const gameHeroLightboxes = Array.from(
  document.querySelectorAll('.game-hero-lightbox')
);

const gameLightBoxVideo = Array.from(
  document.querySelectorAll('.js-game-lightbox-video')
);

const isVideoPlaying = (video) =>
  !!(
    video.currentTime > 0 &&
    !video.paused &&
    !video.ended &&
    video.readyState > 2
  );

// if video is playing hide play button else show play button and pause video
const togglePlayPauseButton = (lightboxEl, video) => {
  const playPauseButton = lightboxEl.querySelector(
    '.js-game-lightbox-play-button'
  );

  if (!isVideoPlaying(video)) {
    playPauseButton.classList.add('hidden');
  } else {
    playPauseButton.classList.remove('hidden');
  }
};

const closeModal = (lightbox, el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    lightbox.classList.remove('is-visible');
    const playPauseButton = lightbox.querySelector(
      '.js-game-lightbox-play-button'
    );
    pauseAllVideos(gameLightBoxVideo, playPauseButton);
  });
};

const preventClosingOfModal = (lightbox) => {
  lightbox.addEventListener('click', (e) => {
    // if e target contains js-prevent-close-modal or any of its children, do nothing
    if (
      e.target.classList.contains('js-prevent-close-modal') ||
      e.target.closest('.js-prevent-close-modal')
    ) {
      return;
    }
    e.currentTarget.classList.remove('is-visible');
    const playPauseButton = e.currentTarget.querySelector(
      '.js-game-lightbox-play-button'
    );

    pauseAllVideos(gameLightBoxVideo, playPauseButton);
  });
};

const pauseAllVideos = (videoArray, playBtn) => {
  videoArray.forEach((video) => {
    video.pause();
    playBtn.classList.remove('hidden');
  });
};

const triggerModal = (modalArray) => {
  modalArray.forEach((modal) => {
    modal.addEventListener('click', (e) => {
      e.preventDefault();

      const parentContainer = e.currentTarget.closest('.js-game-video__parent');

      const gameHeroLightbox = parentContainer.querySelector(
        '.game-hero-lightbox'
      );

      if (!gameHeroLightbox) {
        return;
      }

      modalArray.forEach((otherModal) => {
        if (otherModal !== modal) {
          const otherParentContainer = otherModal.closest(
            '.js-game-video__parent'
          );
          const otherGameHeroLightbox = otherParentContainer.querySelector(
            '.game-hero-lightbox'
          );

          if (otherGameHeroLightbox) {
            otherGameHeroLightbox.classList.remove('is-visible');
          }
        }
      });

      const playPauseButton = gameHeroLightbox.querySelector(
        '.js-game-lightbox-play-button'
      );

      const gameHeroLightboxCloseButton =
        gameHeroLightbox.querySelector('.js-close-modal');

      gameHeroLightbox.classList.add('is-visible');

      const video = gameHeroLightbox.querySelector('.js-game-lightbox-video');

      playPauseButton.addEventListener('click', (e) => {
        e.preventDefault();
        togglePlayPauseButton(gameHeroLightbox, video);
      });

      closeModal(gameHeroLightbox, gameHeroLightboxCloseButton);
      preventClosingOfModal(gameHeroLightbox);
    });
  });
};

const initGameHeroModal = () => {
  gameLightBoxVideo.forEach((video) => {
    const lightboxEl = video.closest('.game-hero-lightbox');
    video.addEventListener('click', (e) => {
      togglePlayPauseButton(lightboxEl, e.currentTarget);
    });
  });

  const gameHeroModalButtonTrigger = Array.from(
    document.querySelectorAll('.js-open-modal')
  );

  if (gameHeroModalButtonTrigger.length === 0) {
    return;
  }

  triggerModal(gameHeroModalButtonTrigger);

  document.addEventListener('keydown', (e) => {
    if (e.keyCode === 27) {
      gameHeroLightboxes.forEach((lightbox) => {
        lightbox.classList.remove('is-visible');
        const playPauseButton = lightbox.querySelector(
          '.js-game-lightbox-play-button'
        );

        pauseAllVideos(gameLightBoxVideo, playPauseButton);
      });
    }
  });
};

initGameHeroModal();
